import { Component, TemplateRef, OnInit, Input, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { EventViewModel } from '../../../../models-views/event.view.model';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { VendorDrawerComponent } from '../../../vendor-drawer/vendor-drawer.component';
import { BehaviorSubject, debounceTime } from 'rxjs';
import { VendorResponseModel } from '../../../../models/vendor.model';
import LoginModel from '../../../../models/user.model';
import { QuotationRequestResponseModel } from '../../../../models/quotation.model';
import { AppCommon } from '../../../../providers/app-common';

interface IModalData {
  eventId: any;
  eventData: any;
}

@Component({
  selector: 'app-vendor-request-modal',
  standalone: false,
  templateUrl: './vendor-request-modal.component.html',
  styleUrl: './vendor-request-modal.component.scss'
})

export class VendorRequestModalComponent implements OnInit {

  readonly nzModalData: IModalData = inject(NZ_MODAL_DATA);
  vendorOptions: any[] = [];
  quotationRequestOptions: any[] = [];
  isLoadingVendorSearch = false;
  @Input() eventId: number | null = null;
  form: FormGroup;
  drawerRef?: NzDrawerRef;
  vendorEmail: string | null = null;
  vendorResponseModel = new BehaviorSubject<VendorResponseModel>(new VendorResponseModel());
  loginModel = new BehaviorSubject<LoginModel>(new LoginModel());
  searchChange$ = new BehaviorSubject('');
  quotationRequestResponseModel = new BehaviorSubject<QuotationRequestResponseModel>(new QuotationRequestResponseModel());
  loadingMsg:string = 'Creating request...'
  loading:boolean = false;


  constructor(
    private vm: EventViewModel, private route: ActivatedRoute, private fb: FormBuilder, private modalRef: NzModalRef,
    private drawerService: NzDrawerService
  ) {
    this.form = this.fb.group({
      access_token: [{ value: null, disabled: true }],
      vendor_response_status: ['PENDING', ],
      vendor: [null, Validators.required],
      quotation_request: [null, Validators.required],
      send_mail: [false]
    });
    if(this.nzModalData.eventData){
      this.updateForm();
    }
    this.searchChange$.pipe(debounceTime(500)).subscribe(name => {
      // if (!name) return;
      this.getVendors(name);
    });
    this.loginModel.next(AppCommon.getloggedInObject());
  }

  ngOnInit(): void {
    // Generate secure key on component initialization
    this.eventId = this.nzModalData.eventId;
    this.vm.parentVendorRequestModalComponent = this;
    this.vm.subscribeToVendors(this.vendorResponseModel);
    this.vm.subscribeToQuotationRequest(this.quotationRequestResponseModel);
    this.vm.getQuotationRequest(1, 100, this.eventId, 'vendor-request-modal');
    this.generateSecureKey();
  }

  updateForm(){
    let d = {
      access_token:this.nzModalData.eventData.access_token,
      vendor_response_status:  this.nzModalData.eventData?.vendor_response_status,
      vendor:  this.nzModalData.eventData.vendor_details?.id,
      quotation_request:  this.nzModalData.eventData?.quotation_request,
      send_mail:  this.nzModalData.eventData?.send_mail
    }
    this.getVendors(this.nzModalData.eventData.vendor_details?.name);
    console.log(d)
    this.form.patchValue(d, this.nzModalData.eventData);
  }

  getVendors(name: string) {
    // this.vm.getVendors(name, 1, 100, 'vendor-request-modal', this.eventId);
    this.vm.getVendors(name, 1, 100, 'vendor-request-modal');
  }

  vendorRecieved(){
    this.vendorOptions = this.vendorResponseModel.value.results;
    this.isLoadingVendorSearch = false;
  }

  vendorRequestCreated(){
    this.form.reset();
    this.modalRef.close(true);
  }

  failedToCreate(){
    this.loadingMsg = 'Creating request...'
    this.loading = false;
  }
  
  vendorRequestRecieved(){
    this.quotationRequestOptions = this.quotationRequestResponseModel.value.results;
  }

  generateSecureKey(e:Event = null){
    // Simple client-side key generation for demonstration
    // In a real application, consider a more robust and secure generation method,
    // possibly involving a backend API call.
    e?.preventDefault();
    const access_token = this.generateRandomString(32);
    this.form.patchValue({
      access_token: access_token,
    });
  }

  generateRandomString(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0987654321';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  handleModalCancel(): void {
    this.form.reset();
    this.modalRef.close();
  }

  onSubmit(): void {
    if (this.form.valid) {

      var payload = this.form.getRawValue();

      if(this.nzModalData.eventData){
      this.loadingMsg = 'Updating request...'
      this.loading = true;
      payload.modified_by_by = this.loginModel.value.user.id;
      // payload.id = this.nzModalData.eventData.quotation_request_vendor_id;
      this.vm.updateVendorRequest(payload, this.nzModalData.eventData.quotation_request_vendor_id);
      } else{
      this.loading = true;
      payload.created_by = this.loginModel.value.user.id;
      this.vm.createVendorRequest(payload);
      }
    
      
    } else {
      console.warn('Form invalid');
      // Mark all fields as touched to display validation errors
      Object.values(this.form.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  onAddNewVendor(): void {
    console.log('Add New Vendor clicked');
  }

  openDrawer(footerTemplate: TemplateRef<void>): void {
    this.drawerRef = this.drawerService.create({
      nzTitle: 'Add New Vendor',
      nzContent: VendorDrawerComponent,
      nzWidth: '50vw',
      nzClosable: true,
      nzContentParams: {
        someInput: 'Initial Value',
      },
      nzFooter: footerTemplate as unknown as TemplateRef<{}>
    });

    this.drawerRef.afterClose.subscribe(result => {
      if (result !== undefined) {
        console.log('Drawer closed with result:', result);
      } else {
        console.log('Drawer dismissed');
      }
    });
  }

  onSearch(event$: any): void {
   
    event$ && (this.isLoadingVendorSearch = true);
    this.searchChange$.next(event$);
  }

  onVendorChange(vendorId: number): void {
    if(vendorId === null) return;
    const selectedVendor = this.vendorOptions.find(v => v.id === vendorId);
    this.vendorEmail = selectedVendor ? selectedVendor.email : null;
  }


  onSendEmailChange(checked: boolean): void {
    console.log('Send email checkbox changed:', checked);
  }

   formatIdToFourDigits(id: number): string {
    const str = 'RQ'
    return id ? str + id.toString().padStart(4, '0') : '';
  }
}